/**
 * KDInput — Theme-aware text input
 *
 * Wraps MUI TextField. Defaults to outlined variant.
 */

import { forwardRef } from "react";
import TextField from "@mui/material/TextField";

const KDInput = forwardRef(({ error, success, disabled, ...rest }, ref) => (
  <TextField
    {...rest}
    ref={ref}
    variant="outlined"
    size="small"
    fullWidth
    disabled={disabled}
    error={error}
    sx={{
      ...(success && {
        "& .MuiOutlinedInput-root": {
          "& .MuiOutlinedInput-notchedOutline": { borderColor: "success.main" },
        },
      }),
      ...rest.sx,
    }}
  />
));

KDInput.displayName = "KDInput";

export default KDInput;
